// removed by extract-text-webpack-plugin
module.exports = {"Button":"AuthButton__-loca-__1-Dnw","Submit":"AuthButton__-loca-__1KwfJ","Cancel":"AuthButton__-loca-__KxS6c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Buttons/AuthButton/AuthButton.css
// module id = 253
// module chunks = 0